export const ACTION_LOGOUT = 'logout';
export const ACTION_REHYDRATE_USER = 'rehydrate_user';
export const ACTION_REHYDRATE_ADMIN_USER = 'rehydrate_admin_user';
